import React, { lazy, Suspense } from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const SettingsContent = lazy(() => import("./SettingsContent"));

const Settings = () => {
    return (
        <Suspense fallback={<DefaultLoader />}>
            <SettingsContent />
        </Suspense>
    );
};

export default Settings;
